export default __webpack_public_path__ + "img/6b86acc43cde7a309bd219d022c9b2b2.svg";